interface SectionProps {
  children: React.ReactNode;
  className?: string | null;
  style?: React.CSSProperties;
}

const Section: React.FC< SectionProps> = ({ children,
  className = "",
  style = {},
 }) => {
  return (
    <section
      className={`xl:py-[100px] md:py-[95px] py-[56px] ${className}`}
      style={style}
    >
      {children}
    </section>
  );
};
export default Section;
